"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.quoteExtractor = exports.fleetsExtractor = exports.Routes = void 0;
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
exports.Routes = {
    GET_RELATED: '/fleets/related',
    ASK_QUOTE: '/fleets/ask_quote',
    GET_ALL_CONFIGS: '/fleets/get_all_configs'
};
var FleetEntity = /** @class */ (function (_super) {
    __extends(FleetEntity, _super);
    function FleetEntity(session) {
        return _super.call(this, {
            session: session,
            entityName: 'fleets',
            routes: [Entity_1.BaseRoutes.GetAll, Entity_1.BaseRoutes.Create, Entity_1.BaseRoutes.Update, Entity_1.BaseRoutes.Delete]
        }) || this;
    }
    FleetEntity.prototype.getAll = function () {
        return this.getAllOrFetch(null, exports.fleetsExtractor, exports.fleetsExtractor);
    };
    FleetEntity.prototype.getById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isAllFetched) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getAll()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.store.getItem(id)];
                }
            });
        });
    };
    FleetEntity.prototype.getByTask = function (taskId) {
        return __awaiter(this, void 0, void 0, function () {
            var fleets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(exports.Routes.GET_RELATED)
                            .withExtractor(exports.fleetsExtractor)
                            .setException('Failed to get related fleet')
                            .withPayload({ task_id: taskId })
                            .invoke()];
                    case 1:
                        fleets = _a.sent();
                        return [2 /*return*/, fleets];
                }
            });
        });
    };
    FleetEntity.prototype.askForQuote = function (taskId, fleetId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post(exports.Routes.ASK_QUOTE)
                        .withExtractor(exports.quoteExtractor)
                        .setException('Failed to get fleet quote')
                        .withPayload({ task_id: taskId, fleet_id: fleetId })
                        .invoke()];
            });
        });
    };
    FleetEntity.prototype.getAllConfigs = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator.get(exports.Routes.GET_ALL_CONFIGS).invoke()];
            });
        });
    };
    return FleetEntity;
}(StoreEntity_1.default));
exports.default = FleetEntity;
var fleetsExtractor = function (response) { return response.fleets; };
exports.fleetsExtractor = fleetsExtractor;
var quoteExtractor = function (response) { return response.result; };
exports.quoteExtractor = quoteExtractor;
//# sourceMappingURL=FleetEntity.js.map